import { render, staticRenderFns } from "./OrticValueSelectModalControl.vue?vue&type=template&id=4bb394b5&"
import script from "./OrticValueSelectModalControl.vue?vue&type=script&lang=js&"
export * from "./OrticValueSelectModalControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports